module.exports = __webpack_public_path__ + "img/ic-warning-circle-gray.svg";